"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgFreeze = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("g", { clipPath: "url(#freeze_svg__a)" },
        React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M2.32 10.985a1.1 1.1 0 0 1 .769-.318H9.66a1 1 0 0 0 0-2H3.09A3.09 3.09 0 0 0 0 11.749v11.736a3.09 3.09 0 0 0 3.089 3.091h5.164L6.97 30h-.64a1 1 0 0 0 0 2h11.993a1 1 0 0 0 0-2h-.64L16.4 26.576h5.164a3.09 3.09 0 0 0 3.089-3.09v-1.82a1 1 0 1 0-2 0v1.82a1.09 1.09 0 0 1-1.09 1.09H3.09a1.09 1.09 0 0 1-1.09-1.09V11.753c0-.289.116-.565.32-.769m8.034 15.682L9.104 30h6.444l-1.25-3.333z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M5.33 15.333a1 1 0 0 1 1-1h7.329a1 1 0 0 1 0 2h-7.33a1 1 0 0 1-.999-1M5.33 20a1 1 0 0 1 1-1h3.998a1 1 0 0 1 0 2H6.33a1 1 0 0 1-1-1", clipRule: "evenodd" }),
        React.createElement("path", { fill: "#D9EAF5", d: "M15 9a8 8 0 1 0 16.001 0A8 8 0 0 0 15 9" }),
        React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M16.636 2.636a9 9 0 1 1 12.728 12.729A9 9 0 0 1 16.636 2.636M23 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14", clipRule: "evenodd" }),
        React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M21.546 4.636a.8.8 0 1 0-.866 1.345l1.52.979V8.2h-1.271l-1.05-1.484a.8.8 0 0 0-1.306.923l.986 1.396-.975 1.31a.8.8 0 0 0 1.284.955l1.116-1.5H22.2v1.24l-1.52.979a.8.8 0 1 0 .866 1.345L23 12.428l1.454.936a.8.8 0 1 0 .866-1.345l-1.52-.979V9.8h1.295l1.02 1.477a.8.8 0 0 0 1.317-.91l-.92-1.332.93-1.419a.8.8 0 1 0-1.337-.877l-.96 1.461H23.8V6.96l1.52-.979a.8.8 0 1 0-.866-1.345L23 5.572z", clipRule: "evenodd" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "freeze_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h32v32H0z" })))));
exports.default = SvgFreeze;
